import { ActionContext, Store } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import { State as RootState } from '../state';
import { AuthState } from './authState';
import { authService } from '../../_services';
import { router } from '../../_router';
import { EnterpriseSignUpInfo } from '../../_models/enterpriseSignUpInfo';

type AuthContext = ActionContext<AuthState, RootState>;

var tempToken: string | null = localStorage.getItem('userToken')
var userToken: string | null = null;
if (tempToken !== null) {
    userToken = JSON.parse(tempToken);
}
// const userToken: string | null = JSON.parse(localStorage.getItem("userToken"))

export const auth = {
    namespaced: true,

    state: userToken ? { token: userToken } : { token: null },

    getters: {
        getToken(state: AuthState) {
            return state.token
        }
    },

    mutations: {
        loginSuccess(state: AuthState, token: string) {
            state.token = token;
        },
        loginFailure(state: AuthState) {
            state.token = null;
        },
        logout(state: AuthState) {
            state.token = null;
        }
    },

    actions: {
        login(context: AuthContext, payload: { username: string, password: string }) {
            return new Promise<string>((resolve, reject) =>{
                authService.login(payload.username, payload.password)
                .then(response => {
                    commitLoginSuccess(context, response)
                    router.push({
                        name: 'profilo',
                        params: {
                            checkComplete: 'true'
                        }
                    });
                    resolve("ok")
                }).catch((error) => {
                    commitLoginFailure(context)
                    reject(error)
                })
            })
        },
        logout(context: AuthContext) {
            authService.logout()
            commitLogout(context)
        },
        signUp(context: AuthContext, payload: EnterpriseSignUpInfo): void {
            authService.signUp(payload).then(() =>{
                router.push('/signUpSuccess');
            }).catch(() =>{
                router.push('/');
            })
        },
        validation(context: AuthContext, payload:string){
            authService.validateUser(payload)
        },
        changeStatus(context: AuthContext, payload: string){
            return new Promise<string>((resolve, reject) =>{
                authService.changeStatus(payload).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })
            })
        }
    }
};

const { commit, read, dispatch } = getStoreAccessors<AuthState, RootState>("auth");
const getters = auth.getters;

export const readToken = read(getters.getToken);

const actions = auth.actions;

export const dispatchLogin = dispatch(actions.login);
export const dispatchLogout = dispatch(actions.logout);
export const dispatchSignUp = dispatch(actions.signUp);
export const dispatchValidation = dispatch(actions.validation);
export const dispatchChangeStatus = dispatch(actions.changeStatus)

const mutations = auth.mutations;

export const commitLoginSuccess = commit(mutations.loginSuccess);
export const commitLoginFailure = commit(mutations.loginFailure);
export const commitLogout = commit(mutations.logout)